module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","goodsType":"Goods Type","name":"Name","code":"Code","alternativeName":"Alternative Name","minTemperature":"Min. temp.","maxTemperature":"Max temp."},"no":{"add":"Laget","remove":"Slettet","goodsType":"Godstype","name":"Navn","code":"Kode","alternativeName":"Alternativt navn","minTemperature":"Min. temp.","maxTemperature":"Maks temp."}}')
  delete Component.options._Ctor
}
